// import { getUserLocale } from '@/i18n'
import Error from '@/views/ErrorView.vue'
import type { RouteRecordRaw } from 'vue-router'
import Menu from './menu'

const recursiveFilteringRoutes = (menu: RouteRecordRaw[]) =>
  menu
    .filter((c) => !c.path.startsWith('__'))
    .map((c) => {
      const cloned = { ...c }
      if (cloned.children) {
        const list = recursiveFilteringRoutes(cloned.children)
        cloned.children = list.length ? list : undefined
      }
      return cloned
    })

const recursiveFilteringMenu = (menu: RouteRecordRaw[]) =>
  menu.reduce((prev, current) => {
    const cloned = { ...current }
    if (cloned.children) {
      const list = recursiveFilteringMenu(cloned.children)
      cloned.children = list.length ? list : undefined
    }
    if (cloned.meta?.menuTitle && !cloned.meta?.hideOnMenu) prev.push(cloned)
    else if (cloned.children) {
      const list = recursiveFilteringMenu(cloned.children)
      prev = prev.concat(list)
    }
    return prev
  }, [] as RouteRecordRaw[])

const routes: RouteRecordRaw[] = [
  // {
  //   path: '/:locale([a-z]{2})',
  //   component: EmptyRouterView,
  //   props: true,
  //   children: [
  {
    path: '',
    name: 'main',
    component: () => import('@/views/HomeView.vue'),
    meta: {
      seo: {
        title: 'Official Website',
        description:
          'Live it up in MapleStory, the original side-scrolling MMORPG! Choose from over 50 customizable classes and save the world from the evil Black Mage.',
        keywords:
          'maplestory, nexon maplestory, maplestory homepage, maplestory main, maplestory official site, maplestory gms',
      },
      gaPageType: 'homepage',
    },
  },
  {
    path: '/survey2024/:rid',
    name: 'survey-coupon',
    component: () => import('@/views/survey2024/index.vue'),
    meta: {
      seo: {
        title: 'Survey Coupon',
      },
      gaPageType: 'survey2024',
    },
  },
  ...recursiveFilteringRoutes(Menu),
  // ],
  // },
  {
    path: '/:catchAll(.*)',
    redirect: 'error',
    // redirect: (to) => {
    //   const paths = to.path.slice(1).split('/')
    //   let path = ''

    //   const locale = getUserLocale()
    //   if (paths[0].length !== 2) {
    //     path = `/${locale}${to.fullPath}`
    //   } else {
    //     path = `/${locale}` // default redirection page
    //   }
    //   return {
    //     path,
    //   }
    // },
  },
  {
    path: '/error',
    name: 'error',
    component: Error,
    meta: {
      seo: {
        title: 'Error',
      },
    },
  },
  {
    path: '/error-general',
    name: 'error-general',
    component: Error,
    meta: {
      seo: {
        title: 'Error',
      },
    },
  },
  {
    path: '/micro-site/:catchAll(.*)',
    redirect: '/',
  },
]

export const MenuList = recursiveFilteringMenu(Menu)

// The unfiltered menu tree. `MenuList` above drops anything the nav does not render, so
// crawling (which is opted into per route via `meta.aiSearchResult`) reads this instead.
// Re-exported from here rather than imported from './menu' directly: entering the module
// graph at './menu' hits the PageBanners -> routes/index cycle and leaves `Menu` undefined.
export const MenuTree = Menu

export const FlatMenuList = MenuList.reduce((prev, cur) => {
  if (cur.children) prev = prev.concat(cur.children)
  else prev.push(cur)
  return prev
}, [] as RouteRecordRaw[])

export default routes
